<template>
  <div class="container">
    <el-checkbox v-model="checked" @change="checkChange"></el-checkbox>
    <div class="content">
      <div class="info">
        <span class="label">发货明细单号：<span>{{detail.deliveryCode}}</span></span>
        <span class="label">发货时间：<span>{{detail.moveDate}}</span></span>
        <span class="label">收货地址：<span>{{detail.pickAdress}}</span></span>
      </div>
      <div class="table-container">
         <el-table
            style="width: 920px;"
            :data="detail.detailList"
            height="300px"
            :header-cell-style="{textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
            :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D',lineHeight:'24px'}">
            <el-table-column
                  label="商品图片">
                  <template slot-scope="scope">
                     <img style="width: 100px;" :src="scope.row.picUrl" />
                  </template>
            </el-table-column>
             <el-table-column
                  label="商品名称" prop="productName">
            </el-table-column>
            <!-- <el-table-column
                  label="商品类型" prop="lineType">
            </el-table-column> -->
            <el-table-column
                  label="规格" prop="spec">
            </el-table-column>
            <el-table-column
                  label="单位" prop="salesUnitName">
            </el-table-column>
            <el-table-column
                  label="数量" prop="actualNum">
            </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: Object
  },
  data: ()=> {
    return {
      checked: false,
    }
  },
  methods: {
    checkChange(val) {
      this.$emit('checkChange',{checked:val,deliveryCode: this.detail.deliveryCode})
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    display: flex;
    align-items: center;
    padding: 10px;
    margin-top: 10px;
    border: 1px solid rgb(223, 223, 223);
    border-radius: 10px;
    .content{
      width: 100%;
      margin-left: 20px;
      .info{
        line-height: 40px;
        .label{
          padding-right: 30px;
        }
      }
    }
  }
</style>